import { Info } from "@phosphor-icons/react";
import { useMemo } from "react";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { getOutreachLicenseCount } from "common/helpers/workspaceLicenseCounts";

export default function ScheduledChangeTag() {
  const selectedWorkspace = useSelectedWorkspaceContext();
  const { licenses } = selectedWorkspace;
  const outreachSeatCount = getOutreachLicenseCount(selectedWorkspace);

  const activeOutreachLicenseCount = useMemo(
    () =>
      licenses.filter(
        ({ source, status }) => source === "aimfox" && status === "active",
      ).length,
    [licenses],
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Tag variant="yellow" rightIcon={<Info weight="fill" />}>
          Upcoming change
        </Tag>
      </TooltipTrigger>

      <TooltipContent>
        This subscription has a scheduled change which will be effective
        starting from your next billing date
        <div className="flex flex-col mt-4">
          <span>Current seats: {outreachSeatCount}</span>
          <span>New seats: {activeOutreachLicenseCount}</span>
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
